import type { GetServerSidePropsContext } from 'next';

import type { AppStore } from 'redux-store';
import getProductsThunks from 'redux-store/thunks/paymentsMethods/getPaymentsMethods';
import getProductsThunk from 'redux-store/thunks/products/getProductsThunks';
import getProductsV3Thunk from 'redux-store/thunks/products/getProductsV3Thunk';
import getPurchasesThunk from 'redux-store/thunks/purchases/getPurchasesThunk';

export class ProductsService {
  async getPaymentMethods(
    { store }: { store: AppStore },
    context: GetServerSidePropsContext | null,
  ): Promise<void> {
    await store.dispatch(getProductsThunks(context));
  }

  async getPurchasesThunk(
    { store }: { store: AppStore },
    context: GetServerSidePropsContext | null,
  ): Promise<void> {
    await store.dispatch(getPurchasesThunk(context));
  }

  async getProducts(
    { store }: { store: AppStore },
    context: GetServerSidePropsContext | null,
  ): Promise<void> {
    if (!context) {
      return;
    }

    await store.dispatch(getProductsThunk(context));
  }

  async getProductsV3(
    {
      store,
      screen,
      coupon,
    }: { store: AppStore; screen: string; coupon?: string },
    context: GetServerSidePropsContext | null,
  ): Promise<void> {
    if (!context) {
      return;
    }

    await store.dispatch(getProductsV3Thunk({ context, screen, coupon }));
  }
}

export const productsService = new ProductsService();
